import { render, staticRenderFns } from "./holzpellets-qualitaet.vue?vue&type=template&id=63dc6834&scoped=true"
import script from "./holzpellets-qualitaet.vue?vue&type=script&lang=ts"
export * from "./holzpellets-qualitaet.vue?vue&type=script&lang=ts"
import style0 from "./holzpellets-qualitaet.vue?vue&type=style&index=0&id=63dc6834&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc6834",
  null
  
)

export default component.exports